import { GatsbyBrowser } from 'gatsby';
import { createRoot } from 'react-dom/client';

import { gtmService } from '~/services/gtm';
import { wrapWithProviders } from '~/utils/gatsbyHelpers';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] =
  wrapWithProviders;

export const replaceHydrateFunction = () => (element, container) => {
  const root = createRoot(container);
  root.render(element);
};

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
  props,
}) => {
  if (!props.location.hash) {
    gtmService.emitPageView(props.pageContext.pageTemplate);
  }

  return element;
};

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = () => {
  gtmService.emitRouteChange();
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
  routerProps: { location },
}) => !location.state?.noScroll;
